import { render, staticRenderFns } from "./CommessaList.vue?vue&type=template&id=d6ca031e&"
import script from "./CommessaList.vue?vue&type=script&lang=js&"
export * from "./CommessaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports